module.exports = __webpack_public_path__ + "static/media/Eid_Eladha_portrait_ar.2b6cb452.jpg";